/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class YcloudPhoneNumbers extends ApiClient {
  constructor() {
    super('ycloud/phone_numbers', { accountScoped: true });
  }

  list(apiKey) {
    return axios.post(this.url, { api_key: apiKey });
  }
}

export default new YcloudPhoneNumbers();
